import styled, { css } from "styled-components";

export const Container = styled.label<{ isError: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;

  input {
    flex: 1;
    font-size: 1rem;
    padding: 0.8rem 1rem;

    outline: none;
    border-radius: 4px;
    border: 2px solid var(--gray-100);
    background-color: var(--gray-100);

    &:not(:disabled):focus {
      border-color: var(--color-3);
    }

    &::placeholder {
      color: var(--gray-600);
    }

    ${({ isError }) =>
      isError &&
      css`
        border-color: var(--danger-300);
      `}
  }

  .label {
    font-weight: 600;
    font-size: 0.9rem;
    color: var(--gray-700);
    margin-bottom: 0.25rem;
  }

  .error,
  .asterisk {
    color: var(--danger-300);
  }

  .error {
    margin-top: 0.25rem;
  }
`;
